import { FormProvider } from 'react-hook-form';
import { TManagerForm } from '../type';
import { RemoteBankingContactsManagerForm } from '~/modules/remote-banking-contacts/forms/RemoteBankingContactsManagerForm.tsx';
import { FormButtonGroup } from '~/modules/processing-personal/PersonalDataApplicationForm/components/styled.ts';
import { Button } from '@mui/material';
import { useManagerForm } from '~/modules/remote-banking-contacts/hooks/useHookForms.ts';

export const ManagerStep = ({ onSubmit }: { onSubmit: (v: TManagerForm) => void }) => {
  const form = useManagerForm();

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <RemoteBankingContactsManagerForm />
        <FormButtonGroup>
          <Button variant="contained" color="primary" type="submit">
            Продовжити
          </Button>
        </FormButtonGroup>
      </form>
    </FormProvider>
  );
};
